import React from 'react';
import "./footer.css"
// import {AiFillFacebook} from 'react-icons/ai'
// import {BsInstagram} from 'react-icons/bs'
// import {AiFillTwitterCircle} from 'react-icons/ai'
import {HiOutlineMail} from 'react-icons/hi'
import {BsLinkedin} from 'react-icons/bs'
import {AiFillGithub} from 'react-icons/ai'
import logo from '../../outerComponents/logo.png'
const Footer = () => {
  return (
    <footer className='outerFooter'>
      <a href="#" className='footer_logo'><img src={logo} alt="" /></a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
      <div className='footer_social'>
      <a href="https://www.linkedin.com/in/pritamhalder62/" target="_blank"><BsLinkedin className='footer-icon'/></a>
      <a href="https://github.com/Halderpritam123" target="_blank"><AiFillGithub className='footer-icon'/></a>
      <a href="mailto:pritampritamhalder@gmail.com" target="_blank"><HiOutlineMail className='footer-icon'/></a>
      </div>
      <div className="footer_copyright">
        <small>&copy;copyright text</small>
      </div>
    </footer>
  );
}

export default Footer;
